// Utilidades compartidas del flujo de correcciones a nivel de marcaje (Punto C).

// 'HH:MM:SS' | 'HH:MM' → 'HH:MM'
export const hhmm = (t) => (t ? String(t).slice(0, 5) : '')

// Texto legible de una operación de corrección, para resúmenes y diffs.
export function resumirOperacion(op) {
  const vp = op.valores_propuestos || {}
  const vo = op.valores_originales || {}
  if (op.accion === 'crear' && op.objetivo === 'turno') return `Crear turno ${hhmm(vp.hora_entrada) || '—'} → ${hhmm(vp.hora_salida) || '—'}`
  if (op.accion === 'crear' && op.objetivo === 'pausa') return `Añadir pausa ${hhmm(vp.hora_inicio) || '—'} → ${hhmm(vp.hora_fin) || '—'}`
  if (op.accion === 'eliminar' && op.objetivo === 'turno') return `Eliminar turno completo${vo.hora_entrada ? ` (${hhmm(vo.hora_entrada)} → ${hhmm(vo.hora_salida)})` : ''}`
  if (op.accion === 'eliminar' && op.objetivo === 'pausa') return `Eliminar pausa${vo.hora_inicio ? ` (${hhmm(vo.hora_inicio)} → ${hhmm(vo.hora_fin)})` : ''}`
  if (op.accion === 'modificar' && op.marcaje === 'entrada') return `Entrada: ${hhmm(vo.hora_entrada) || '—'} → ${hhmm(vp.hora_entrada)}`
  if (op.accion === 'modificar' && op.marcaje === 'salida') return `Salida: ${hhmm(vo.hora_salida) || '—'} → ${hhmm(vp.hora_salida)}`
  if (op.accion === 'modificar' && op.marcaje === 'inicio_pausa') return `Inicio de pausa: ${hhmm(vo.hora_inicio) || '—'} → ${hhmm(vp.hora_inicio)}`
  if (op.accion === 'modificar' && op.marcaje === 'fin_pausa') return `Fin de pausa: ${hhmm(vo.hora_fin) || '—'} → ${hhmm(vp.hora_fin)}`
  return 'Cambio'
}

// Props de Pill según estado de una solicitud-bloque.
export const estadoCorreccionPill = (estado) => {
  if (estado === 'aprobada') return { tone: 'emerald', label: 'Aprobada' }
  if (estado === 'rechazada') return { tone: 'red', label: 'Rechazada' }
  return { tone: 'amber', label: 'Pendiente' }
}
